/* eslint semi: 1, react/prop-types:1 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import logoImage from '../images/LiteracyStarterIcon.png';

const Header = ({ activeRoute }) => {

    const styles = {
        jumbotron: {
            backgroundColor: '#e1d7c4',
            paddingTop: 38,
            paddingBottom: 68,
            marginBottom: 0
        },
        flexContainer: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'center'
        },
        imageContainer: {
            width: 130,
            height: 'auto',
            marginTop: 20
        },
        titleContainer: {
            marginLeft: 20
        },
        title: {
            marginBottom: 5,
            fontSize: 68,
            cursor: 'default',
            fontFamily: 'Rajdhani, "Open Sans", sans-serif'
        },
        subtitle: {
            marginTop: 0,
            cursor: 'default',
            fontSize: 20,
            lineHeight: '30px',
            fontStyle: 'italic'
        },
        navbarContainer: {
            backgroundColor: '#222',
            height: 50,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'center'
        },
        navbarItemContainer: {},
        navItem: {}
    };

    return (
        <div>
            <div className="jumbotron" style={styles.jumbotron}>
                <div style={styles.flexContainer}>
                    <div className="hidden-on-xs">
                        <img style={styles.imageContainer} src={logoImage} alt="Literacy Starter"></img>
                    </div>
                    <div className="title-container" style={styles.titleContainer}>
                        <h1 style={styles.title}>Literacy Starter</h1>
                        <h3 className="subtitle-header" style={styles.subtitle}>Aiding Literacy Professionals Around The World</h3>
                    </div>
                </div>
            </div>
            <nav>
                <div style={styles.navbarContainer}>
                    <div className="navbar-item-container" style={styles.navbarItemContainer}>
                        <Link to="/">
                            <div className={activeRoute === '/' ? 'active' : ''} style={styles.navItem}>
                                <i className="fa fa-home" aria-hidden="true"></i> Home
                            </div>
                        </Link>
                    </div>
                    <div className="navbar-item-container" style={styles.navbarItemContainer}>
                        <Link to="/downloads">
                            <div className={activeRoute === '/downloads' ? 'active' : ''} style={styles.navItem}>
                                <i className="fa fa-arrow-circle-o-down" aria-hidden="true"></i> Downloads
                            </div>
                        </Link>
                    </div>
                    <div className="navbar-item-container" style={styles.navbarItemContainer}>
                        <Link to="/contact">
                            <div className={activeRoute === '/contact' ? 'active' : ''} style={styles.navItem}>
                                <i className="fa fa-envelope-o" aria-hidden="true"></i> Contact
                            </div>
                        </Link>
                    </div>
                </div>
            </nav>
        </div>
    );
};
Header.propTypes = {
    activeRoute: PropTypes.string
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/header.js
 **/